import SliderGame from './SliderGame';
export default SliderGame;
